import React from 'react';
import {
  NotificationType,
  NotificationRenderFunction,
  NotificationQueueItem,
} from '../redux/types';
import NotificationContent from '../_partials/NotificationContent';
import { useCustomNotifications } from '../CustomNotificationContext';

export interface Props {
  notificationTypes?: (string | NotificationType)[];
  notificationFilter?: (notification: NotificationQueueItem) => boolean;
  customNotificationRender?: NotificationRenderFunction;
}

export const CustomNotification: React.FC<Props> = ({
  notificationTypes,
  notificationFilter = () => true,
  customNotificationRender,
}) => {
  const { notifications, removeNotification } = useCustomNotifications(notificationTypes);
  const currentNotification = notifications[0];

  if (!currentNotification || !notificationFilter(currentNotification)) {
    return null;
  }

  return (
    <NotificationContent notification={currentNotification} removeNotification={removeNotification}>
      {customNotificationRender}
    </NotificationContent>
  );
};
CustomNotification.displayName = 'CustomNotification';

export default CustomNotification;
